import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

import { Button, Dialog, Skeleton } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import type { KhoaDich } from '../../../../i18n';
import { LoiRpa } from '../chung';
import { useQuyenLicense } from '../../hooks/useLicense';
import type { LicenseRpa, QuyenOpenCoreLicense } from '../../types';

const MUC: { k: keyof QuyenOpenCoreLicense; khoa: KhoaDich }[] = [
  { k: 'licenseAllowed', khoa: 'rpaLicense.quyen.licenseAllowed' },
  { k: 'userFound', khoa: 'rpaLicense.quyen.userFound' },
  { k: 'roleFound', khoa: 'rpaLicense.quyen.roleFound' },
  { k: 'roleMember', khoa: 'rpaLicense.quyen.roleMember' },
  { k: 'invokeGranted', khoa: 'rpaLicense.quyen.invokeGranted' },
  { k: 'inSync', khoa: 'rpaLicense.quyen.inSync' },
];

/**
 * Kiểm quyền thực tế trên OpenCore của một License (`GET /licenses/:id/opencore-access`): License còn hiệu lực, User và
 * role License còn trên OpenCore, User có trong role, database ghi đã cấp quyền chạy, và mọi thứ có khớp nhau không.
 */
export function HopQuyenOpenCore({ license, onClose }: { license: LicenseRpa; onClose: () => void }) {
  const { t } = useT();
  const q = useQuyenLicense(license.id);
  return (
    <Dialog
      open
      onClose={onClose}
      width={480}
      title={t('rpaLicense.quyen.tieuDe', { ten: license.opencore_username || license.opencore_user_id || license.project_id })}
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.dong')}
          </Button>
        </div>
      }
    >
      {q.isPending ? (
        <Skeleton className="h-40 w-full" />
      ) : q.isError ? (
        <LoiRpa loi={q.error} onThuLai={() => void q.refetch()} />
      ) : (
        <ul className="divide-y divide-default rounded-lg border border-default">
          {MUC.map(({ k, khoa }) => {
            const co = q.data[k];
            return (
              <li key={k} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
                <span className="text-content-secondary">{t(khoa)}</span>
                <span className={`inline-flex shrink-0 items-center gap-1.5 font-medium ${co ? 'text-success-700' : 'text-danger-700'}`}>
                  {co ? <CheckCircleOutlined aria-hidden /> : <CloseCircleOutlined aria-hidden />}
                  {co ? t('rpaLicense.quyen.co') : t('rpaLicense.quyen.khong')}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </Dialog>
  );
}
